import http from "@/http-common";
import {SelectBoxItem} from "@/api/SelectBoxItem";

class CityService {
    async getCities(provinceId?: number): Promise<SelectBoxItem[]> {
        const queryParams: { [k: string]: string } = {};
        if (provinceId) {
            queryParams.cc = provinceId.toString();
        }
        const url = '/geolocation/location/getallcities';
        const response = await http.get<string[][]>(url, {params: queryParams});
        return response.data.map(city => new SelectBoxItem(city[1], city[1]));
    }
}

export default new CityService();